<div class="container-inner">
  <h1 class="text-center my-3">Setup Activity Tracker</h1>


  <div  *ngIf="!trackerSyncStatus">
    <app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
  </div>

  <div *ngIf="trackerSyncStatus">
    <div *ngIf="trackerSyncStatus.status == 'success'">
        <div *ngIf="trackerSyncStatus.status=='success'">Your device is connected and we are receiving data.  You have {{ trackerSyncStatus.data.steps}} steps today. </div>
        <div class="text-center"><button class="btn btn-primary mt-2" (click)="onDisconnect()">Disconnect</button></div>
    </div>
    <div *ngIf="trackerSyncStatus.status != 'success' && trackerStatus">
        <div *ngIf="trackerStatus.status=='success'" class="text-center">
          <p>Your device is connected</p> 
          <a [routerLink]="['/activity']" class="btn btn-primary">Back to Move Well</a>
        </div>
        <div *ngIf="trackerStatus.status=='disconnected'" class="text-center">
          <p>No device is currently connected to this account.</p>
            <a href="{{trackerStatus.url}}" class="btn btn-primary">Connect Your Garmin Device</a>
        </div>
        
    </div>
  </div>
</div>
